import React from 'react';
import {connect} from 'react-redux';
import {selectSshkey} from '../store/sshkeyActions'

//https://developer.mozilla.org/en-US/docs/Web/CSS/word-break

const SshKeyItem = ({sshkey,selectSshkey}) => {
  const onDelete = () => selectSshkey({sshkey});
  return (
    <>
      { sshkey &&
        <div className='card horizontal light-blue lighten-5'>
          <div className='card-stacked'>
            <div className='card-content'>
              <div style={{'wordBreak':'break-all'}}>{sshkey}</div>
            </div>
            <div className='card-action'>
              <button className='btn btn-primary btn-block modal-trigger' href='#modal1' onClick={onDelete}>delete</button>
            </div>
          </div>
        </div>
      }
    </>
  )
};

export default connect(null,{selectSshkey})(SshKeyItem)

